import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { categoriesApi } from '@/api/categories'
import type { PoiCategoryConfig } from '@/api/types'

export const useCategoryStore = defineStore('categories', () => {
  const categories = ref<PoiCategoryConfig[]>([])
  const loaded = ref(false)

  const colorMap = computed<Record<string, string>>(() =>
    Object.fromEntries(categories.value.map(c => [c.key, c.color]))
  )

  const labelMap = computed<Record<string, string>>(() =>
    Object.fromEntries(categories.value.map(c => [c.key, c.label]))
  )

  function getColor(key: string): string {
    return colorMap.value[key] ?? '#6b7280'
  }

  function getLabel(key: string): string {
    return labelMap.value[key] ?? key
  }

  async function load() {
    if (loaded.value) return
    try {
      categories.value = await categoriesApi.getAll()
      loaded.value = true
    } catch {
      // use empty list; views fall back to grey
    }
  }

  return { categories, loaded, colorMap, labelMap, getColor, getLabel, load }
})
